/**
 * Module-level drag-state store. Browsers' HTML5 dataTransfer is a
 * fiddly contract — custom MIMEs sometimes don't appear in `types`
 * during dragover, dropping the timeline target's "I'll accept this"
 * preventDefault and silently canceling the drop. Mirroring the drag
 * source's info in a plain module-level ref sidesteps the whole API
 * for in-app drags.
 *
 * Set on dragstart by ProjectAssetsPanel, cleared on dragend, read by
 * Timeline on dragover + drop. dataTransfer still gets the data too
 * for cross-window / external drag interoperability.
 */
import type { ProjectAsset } from '../../types/editor';

export interface AssetDragState {
  assetId: number;
  kind: ProjectAsset['kind'];
}

let current: AssetDragState | null = null;

export function setCurrentAssetDrag(state: AssetDragState | null): void {
  current = state;
}

export function getCurrentAssetDrag(): AssetDragState | null {
  return current;
}
